module.exports = __webpack_public_path__ + "static/media/orange-sms-tracking.d012cf24.svg";